import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import ReactTooltip from 'react-tooltip';

import Page from 'components/Page';
import {Container} from 'containers/types';
import {
  default as LoginRequired,
  LoginRequiredProps
} from 'components/LoginRequired';
import VisibleIf from 'components/VisibleIf';

import {requiresPermission, PERMISSIONS} from 'ducks/auth';

import {OCCUPANCY_TYPE_CHOICES, REPORT_SHAPE} from 'ducks/occupancy';

import {
  LiveAvailabilitySection,
  OverviewSection,
  PhysicalSwitchSection,
  RoomPurposeOverviewSection
} from './components';

import './styles.css';

class Occupancy extends React.Component<
  Container & LoginRequiredProps & typeof mapDispatchToProps
> {
  componentDidMount() {
    const locationRef = this.props.match.params.locationRef;

    this.props.requiresPermission({
      permission: PERMISSIONS.VIEW_OCCUPANCY_DASHBOARD,
      locationRef
    });
  }

  state = {
    occupancyType: OCCUPANCY_TYPE_CHOICES.REVENUE_OCCUPANCY,
    currentOverview: REPORT_SHAPE.BOOKING_TYPE
  };

  toggleViewRenderer = value => {
    if (_.get(OCCUPANCY_TYPE_CHOICES, value, false)) {
      throw new Error(`${value} is not a valid view choice`);
    }
    if (value === OCCUPANCY_TYPE_CHOICES.REVENUE_OCCUPANCY) {
      this.setState({currentOverview: REPORT_SHAPE.BOOKING_TYPE});
    }
    this.setState({occupancyType: value}, () => ReactTooltip.rebuild());
  };
  toggleOverviewSectionRenderer = value => {
    this.setState({currentOverview: value}, () => ReactTooltip.rebuild());
  };

  render() {
    const {match: {params: {locationRef}}} = this.props;
    return (
      <Page activeTab="occupancy" locationRef={locationRef}>
        <div className="Occupancy">
          <VisibleIf
            permission={PERMISSIONS.VIEW_OCCUPANCY_DASHBOARD}
            locationRef={locationRef}>
            <div className="mainContent">
              <div className="container">
                <PhysicalSwitchSection
                  activeTab={this.state.occupancyType}
                  onChange={this.toggleViewRenderer}
                />
                <LiveAvailabilitySection
                  locationRef={locationRef}
                  activeTab={this.state.occupancyType}
                />
                <React.Fragment>
                  {this.state.currentOverview != REPORT_SHAPE.ROOM_PURPOSE && (
                    <OverviewSection
                      locationRef={locationRef}
                      activeTab={this.state.occupancyType}
                      toggleOverviewSectionRenderer={
                        this.toggleOverviewSectionRenderer
                      }
                      currentOverviewSection={this.state.currentOverview}
                    />
                  )}
                  {this.state.currentOverview == REPORT_SHAPE.ROOM_PURPOSE && (
                    <RoomPurposeOverviewSection
                      locationRef={locationRef}
                      activeTab={this.state.occupancyType}
                      toggleOverviewSectionRenderer={
                        this.toggleOverviewSectionRenderer
                      }
                    />
                  )}
                </React.Fragment>
              </div>
            </div>
          </VisibleIf>
        </div>
      </Page>
    );
  }
}

const mapDispatchToProps = {
  requiresPermission
};

export default connect(null, mapDispatchToProps)(LoginRequired(Occupancy));
